const announcementsHR = {
    "view": {
        "dropdown": {
            "unreadHeading": "{{count}} nepročitanih obavijesti",
            "empty": "Nema obavijesti",
            "newBadge": "Novo",
            "dismissAll": "Odbaci sve",
        },
        "modal": {
            "defaultTitle": "Obavijest",
        },
        "table": {
            "title": "Obavijesti",
            "column": {
                "title": "Naslov",
                "datePosted": "Datum objave",
                "dismissed": "Odbačeno",
                "status": "Status",
                "action": "Akcija",
            },
            "status": {
                "read": "Pročitano",
                "unread": "Nepročitano",
            },
            "csv": {
                "statusRead": "Pročitano",
                "statusUnread": "Nepročitano",
                "dismissedYes": "Odbačeno",
                "dismissedNo": "Nije odbačeno",
            },
            "action": {
                "view": "Pogled",
            },
            "button": {
                "exportCsv": "Izvezi CSV",
            },
        },
    },
};

export default announcementsHR;
